import { Select } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, width } from 'styled-system';

const StyledSelect = styled(Select)`
  width: 100%;
  ${width};
  ${space};
`;

export function SelectControl({ settings, name, onChange, onBlur, ...props }) {
  return (
    <StyledSelect
      style={{ width: '100%' }}
      name={name}
      showSearch
      filterOption={(input, option) =>
        (option.label || option.children)?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
      }
      onChange={value => onChange({ target: { name, value } })}
      onBlur={value => onBlur({ target: { name, value } })}
      getPopupContainer={(trigger) => trigger.parentNode}
      {...settings}
      {...props}
    />
  );
}

SelectControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
